import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_evrq835k7x: FaireBrandEntity = {
  token: "b_evrq835k7x",
  type: "brand",
  name: "Touchland",
  avatarUrl: "https://cdn.faire.com/fastly/bf07143c93abbd7ddaa281a7081bd7a6adf0c0d29b67c02637fd6d18de6fbfeb.png",
  bannerUrl: "https://cdn.faire.com/fastly/8dbc7ea809c7682ad77d8fddc9276119f7a1b9e66ef5756fb76566b403f6aee5.png",
  logoUrl: "https://cdn.faire.com/fastly/bf07143c93abbd7ddaa281a7081bd7a6adf0c0d29b67c02637fd6d18de6fbfeb.png",
  heroImageUrl: "https://cdn.faire.com/fastly/8dbc7ea809c7682ad77d8fddc9276119f7a1b9e66ef5756fb76566b403f6aee5.png",
  location: "Miami, FL, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 443,
  isTopShop: true,
  isInsider: true,
  description: "Born from entrepreneur Andrea Lisbona’s vision and launched via Kickstarter in 2018, Touchland creates design-driven, sensorial essentials that turn everyday routines into moments of joy. From skincare-forward Hand Sanitizer Mists to mood-boosting Body & Hair Fragrance Mists, and collectible accessories, every product is designed for life on the go. Trusted by millions, Touchland is stocked in over 2,500 retailers, including Sephora and ULTA, driving standout shelf presence, gifting appeal, and strong repeat purchase.   ",
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:56:46.644Z",
    importedBy: "entity-db-cli"
  }
};
